// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"7ac65e0e","143":"afcf8962","424":"7d544daa","494":"47b3bb42","533":"d1e3c96e","651":"d1bce0ea","690":"8caa8baa","852":"c1ac6b4a","940":"d540c277"}[chunkId] + ".chunk.js";
};